import { Button, Content, ContentVariants, Skeleton, Stack, StackItem } from "@patternfly/react-core";
import type { FC } from "react";
import CommunityPeopleIcon from "../../../assets/Icon-Red_Hat-Community_People-A-Red-RGB.png";
import type { DragHandleProps } from "../../../constants/CardsStructure";
import { usePartnerInfo } from "../../../queries/partnerInfo";
import { DashboardCard } from "../shared/DashboardCard";

const MANAGE_USERS_LINKS = [
	{
		label: "Invite coworkers to the Partner Portal",
		href: "https://partners.connect.redhat.com/s/account-management?tabset-b921c=2",
	},
	{
		label: "Manage requests to join",
		href: "https://partners.connect.redhat.com/s/account-management?tabset-b921c=10876",
	},
	{
		label: "Integrate your IDP with Red Hat",
		href: "https://console.redhat.com/iam/authentication-policy/identity-provider-integration",
	},
];

const ManageMyCompanyCardBody: FC = () => {
	const { isPending: isPartnerInfoLoading } = usePartnerInfo();

	return (
		<Stack hasGutter>
			<StackItem>
				{isPartnerInfoLoading ? (
					<>
						<Skeleton width="50%" fontSize="md" />
						<Skeleton width="80%" fontSize="sm" style={{ marginTop: 4 }} />
						<Skeleton width="60%" fontSize="sm" style={{ marginTop: 4 }} />
						<Skeleton width="70%" fontSize="sm" style={{ marginTop: 4 }} />
					</>
				) : (
					<>
						<Content>
							<Content component={ContentVariants.h4} style={{ marginBottom: "4px" }}>
								Manage users
							</Content>
						</Content>
						{MANAGE_USERS_LINKS.map((link) => (
							<div key={link.label}>
								<Button
									component="a"
									href={link.href}
									target="_blank"
									variant="link"
									isInline
									style={{ fontSize: "var(--pf-t--global--font--size--sm)" }}
								>
									{link.label}
								</Button>
							</div>
						))}
					</>
				)}
			</StackItem>
		</Stack>
	);
};

export const ManageMyCompanyCard: FC<{ dragHandleProps?: DragHandleProps | undefined }> = ({ dragHandleProps }) => (
	<DashboardCard
		icon={CommunityPeopleIcon}
		title="Manage my company"
		isLoading={false}
		cardBody={<ManageMyCompanyCardBody />}
		footerLinks={[{ label: "View user dashboard", href: "https://partners.connect.redhat.com/s/account-management" }]}
		dragHandleProps={dragHandleProps}
	/>
);
